import { useState } from "react";
import { UserBlockProps } from "..";
import { Block } from "@components/block";
import { Grid, GridCol } from "@components/grid";
import { Input } from "@components/input";
import { FlexLoader } from "@components/loader";
import { CustomSelect } from "@components/select";
import { BalancesModal } from "@components/userModals/balance";
import { AdminCachesModal } from "@components/userModals/caches";
import { useAdminUsers } from "@features/admin/users";
import { AdminUserTypes, UserInfoBalance } from "@features/admin/users/api";
import { useAuth } from "@features/auth";
import { useBoolState } from "@hooks/use-bool-state";
import { useParams } from "react-router-dom";
import { ComissionModal } from "../comissionModal";
import { Button } from "@components/button";
import styles from "../selectedUser.module.scss";

export const MerchantBlock = ({ control }: UserBlockProps) => {
  const { selectedUserId } = useParams();
  const { isAdmin, isSuperUser } = useAuth();
  const { state } = useAdminUsers();
  const [isModalOpen, showModal, hideModal] = useBoolState(false);
  const [isCacheModalOpen, showCacheModal, hideCacheModal] =
    useBoolState(false);
  const [isCommissionModalOpen, showCommissionModal, hideCommissionModal] =
    useBoolState(false);
  const [userBalance, setUserBalance] = useState<UserInfoBalance | null>(null);
  const onOffOption = [
    { text: "Вкл", value: "true" },
    { text: "Выкл", value: "false" },
  ];
  const openModalOnBalance = () => {
    if (state.userInfo == null || state.userInfo.kind != AdminUserTypes.Merchant) return;
    setUserBalance(state.userInfo.balance);
    showModal();
  };
  return (
    <>
      <Block className={styles.block}>
        <h3>Мерчант</h3>
        {state.loading ? (
          <FlexLoader />
        ) : (
          <Grid>
            <GridCol span={3}>
              <Button
                buttonType="button"
                onClick={() => openModalOnBalance()}
                disabled={!isSuperUser}
              >
                Мерч баланс
              </Button>
            </GridCol>
            <GridCol span={3}>
              <Button
                buttonType="button"
                onClick={showCommissionModal}
                disabled={!isSuperUser}
              >
                Комиссии
              </Button>
            </GridCol>
            {<GridCol span={3}>
              <Input
                name="commission_pay_out"
                control={control}
                type="number"
                placeholder="Комиссия мерчант Pay-out"
                label="Комиссия мерчант Pay-out"
                disabled={!isSuperUser}
              ></Input>
            </GridCol>}
            <GridCol span={3}>
              <CustomSelect
                control={control}
                options={onOffOption}
                name="pay_out"
                label="Pay-out"
                disabled={!isAdmin}
              ></CustomSelect>
            </GridCol>
            <GridCol span={3}>
              <CustomSelect
                control={control}
                options={onOffOption}
                name="pay_in"
                label="Pay-in"
                disabled={!isAdmin}
              ></CustomSelect>
            </GridCol>
            <GridCol span={3}>
              <Button
                buttonType="button"
                onClick={showCacheModal}
                disabled={!isSuperUser}
              >
                Кассы
              </Button>
            </GridCol>
            <GridCol span={3}>
              <Input
                name="min_sum_order"
                control={control}
                type="number"
                placeholder="Мин сумма ордера Pay-in"
                label="Мин сумма ордера Pay-in"
                disabled={!isSuperUser}
              ></Input>
            </GridCol>
            <GridCol span={3}>
              <Input
                name="max_sum_order"
                control={control}
                type="number"
                placeholder="Макс сумма ордера Pay-in"
                label="Макс сумма ордера Pay-in"
                disabled={!isSuperUser}
              ></Input>
            </GridCol>
            <GridCol span={3}>
              <Input
                name="min_sum_pay_out_order"
                control={control}
                type="number"
                placeholder="Мин сумма ордера Pay-out"
                label="Мин сумма ордера Pay-out"
                disabled={!isSuperUser}
              ></Input>
            </GridCol>
            <GridCol span={3}>
              <Input
                name="max_sum_pay_out_order"
                control={control}
                type="number"
                placeholder="Макс сумма ордера Pay-out"
                label="Макс сумма ордера Pay-out"
                disabled={!isSuperUser}
              ></Input>
            </GridCol>
            <GridCol span={3}>
              <Input
                name="team_lead_commission_pay_in"
                control={control}
                type="number"
                placeholder="Комиссия тимлида pay-in"
                label="Комиссия тимлида pay-in"
                disabled={!isSuperUser}
              ></Input>
            </GridCol>
            <GridCol span={3}>
              <Input
                name="commission_for_trader_pay_out"
                control={control}
                type="number"
                placeholder="% Трейдера пейаут"
                label="% Трейдера пейаут"
                disabled={!isSuperUser}
              ></Input>
            </GridCol>
          </Grid>
        )}
      </Block>
      {selectedUserId && (
        <AdminCachesModal
          isModalOpen={isCacheModalOpen}
          hideModal={hideCacheModal}
          userId={selectedUserId}
        />
      )}
      {userBalance != null && selectedUserId != null && (
        <BalancesModal
          isModalOpen={isModalOpen}
          hideModal={hideModal}
          title={"Баланс мерча"}
          type={"Ern_Pay_IN"}
          userBalance={userBalance}
          userId={selectedUserId}
          isMerchant={true}
        />
      )}
      <ComissionModal
        isOpen={isCommissionModalOpen}
        onClose={hideCommissionModal}
        control={control}
        isTrader={false}
      />
    </>
  );
};
